import React, { useEffect, useState } from "react";
import PageBuilderRowService from "../../../services/page-builder-row.service";
import {
    Grid,
    Button,
    DialogActions,
    DialogContent,
    Divider,
    TextField
} from "@material-ui/core";
import Loading from "../../../components/loading";
import DialogTitle from "../../../components/dialog-title";
import { Form, Formik } from "formik";
import MuiAutocomplete from "@material-ui/lab/Autocomplete";
import glassesService from "../../../services/glasses.service";
import { useErrorHandler } from "../../../hooks";

export default function FormModalContent({ close, data, extra }) {
    const errorHandler = useErrorHandler();

    const [waiting, setWaiting] = useState(false);
    const [searchOption, setSearchOption] = useState("")
    const [searchKeys, setSearchKeys] = useState("")
    const [defaultValues, setDefaultValues] = useState(null)
    const [options, setOptions] = useState([])

    const getOptionLabel = () => {
        const labelSelector = "title";
        if (!labelSelector) return;
        if (typeof labelSelector === "string") {
            return (option) => `${option[labelSelector]}`;
        }
        return labelSelector;
    };
    const [state, setState] = useState({
        title: "",
        discount: 0,
    })

    const handleChangeValue = (key, value) => {
        setState(prev => ({
            ...prev,
            [key]: value
        }))
    }

    const handleSubmit = async () => {
        console.log(state, searchKeys);
        setWaiting(true);

        let op = null;
        if (data && data.id) {
            op = await glassesService.handleUpdateGroupOfChange(data.id, {
                ...state,
                discount: Number(state.discount),
                glassIds: searchKeys.map(item => item.value)
            });
        } else {
            op = await glassesService.handleCreateGroupOfChange({
                ...state,
                discount: Number(state.discount),
                glassIds: searchKeys.map(item => item.value)
            });
        }
        setWaiting(false);

        const { error } = op;
        if (error) return errorHandler(error);

        close(true);
    };

    const searchInGlasses = async (searchKey) => {
        let query = [
            `page=1`,
            `perpage=20`,
            `search=${searchKey}`,
        ];
        glassesService.getGlasses(query).then(res => {
            if (res?.data?.items) {
                setOptions(res?.data?.items.map(item => ({
                    title: `${item.name} - ${item.brand.name}`,
                    value: item.id
                })))
            }
        }).catch(err => { })
    }

    useEffect(() => {
        searchInGlasses(searchOption)
    }, [searchOption]);

    useEffect(() => {
        if (data && data.id) {
            setState({
                title: data.title,
                discount: data.discount
            });

            try {
                const op = data.glasses.map(item => ({
                    title: `${item.name} - ${item.brand.name}`,
                    value: item.id
                }));

                setDefaultValues(op);
                setOptions(op);
                setSearchKeys(op);
            } catch(err){
                setDefaultValues([])
            }
        } else {
            setDefaultValues([])
        }
    }, [])

    if (defaultValues === null) {
        return null
    }

    console.log(77777, defaultValues);

    return (
        <Loading isLoading={waiting} fullPage={true} overlay>
            <DialogTitle onClose={() => close()}>انتخاب عینک</DialogTitle>
            <Divider />
            <Formik
                initialValues={{}}
                onSubmit={handleSubmit}
            >
                {({ isSubmitting, values }) => (
                    <Form autoComplete="off">
                        <DialogContent style={{ overflowX: "hidden" }}>
                            <Grid container spacing={2}>

                                <Grid items xs={12}>
                                    <TextField
                                        label="عنوان"
                                        value={state.title}
                                        variant="outlined"
                                        fullWidth
                                        onChange={(e) => handleChangeValue("title", e.target.value)}
                                    />
                                </Grid>
                                <Grid items xs={6} className="mt-2 d-flex align-center">
                                    <TextField
                                        label="درصد تخفیف"
                                        value={state.discount}
                                        variant="outlined"
                                        fullWidth
                                        onChange={(e) => handleChangeValue("discount", e.target.value)}
                                        inputProps={{
                                            min: 0,
                                            max: 100,
                                        }}
                                    />
                                </Grid>
                                <Grid items xs={12} className="p-1">
                                    <MuiAutocomplete
                                        multiple={true}
                                        options={options}
                                        onKeyUp={(e) => setSearchOption(e.target.value)}
                                        getOptionLabel={getOptionLabel()}
                                        defaultValue={defaultValues}
                                        noOptionsText="هیچ گزینه ای یافت نشد."
                                        onChange={(e, values) => setSearchKeys(values)}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                label={"عینک"}
                                                InputProps={{
                                                    ...params.InputProps,
                                                    endAdornment: (
                                                        <React.Fragment>
                                                            {params.InputProps.endAdornment}
                                                        </React.Fragment>
                                                    ),
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={close} color="primary" disabled={isSubmitting}>
                                لغو
                            </Button>
                            <Button
                                type="submit"
                                disabled={isSubmitting}
                                variant="contained"
                                color="primary"
                            >
                                ثبت
                            </Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Loading>
    );
}
